@if (activity != null) {
<p>
  Last updated:
  <relative-time [iso]="activity.created_at" [precise]="true"></relative-time>
  by {{ activity | userName }}
</p>
}
